import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { lazy, Suspense } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { Layout } from '@/components/Layout';
import { Toaster } from '@/components/ui/sonner';

const Home = lazy(() => import('@/routes/Home'));
const Healthz = lazy(() => import('@/routes/Healthz'));
const Pipeline = lazy(() => import('@/routes/Pipeline'));
const Explorer = lazy(() => import('@/routes/Explorer'));
const BuyPlans = lazy(() => import('@/routes/BuyPlans'));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<Loading />}>
            <Home />
          </Suspense>
        ),
      },
      {
        path: 'healthz',
        element: (
          <Suspense fallback={<Loading />}>
            <Healthz />
          </Suspense>
        ),
      },
      {
        path: 'pipeline',
        element: (
          <Suspense fallback={<Loading />}>
            <Pipeline />
          </Suspense>
        ),
      },
      {
        path: 'explorer',
        element: (
          <Suspense fallback={<Loading />}>
            <Explorer />
          </Suspense>
        ),
      },
      {
        path: 'buy-plans',
        element: (
          <Suspense fallback={<Loading />}>
            <BuyPlans />
          </Suspense>
        ),
      },
    ],
  },
]);

function Loading() {
  return <div className="text-sm text-gray-500">Loading…</div>;
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster richColors closeButton position="top-right" />
    </QueryClientProvider>
  );
}
